import { combineReducers } from "redux";
import { componentManagementReducer, ComponentManagementState } from "./comp.reducer";
import { uiReducer, UiState } from "./ui.reducer";
import { userReducer, UserState } from "./user.reducer";
import { editorialTemplatesReducer, EditorialTemplatesState } from "./editorialTemplates.reducer";

export interface ApplicationState {
    user: UserState,
    ui: UiState,
    editorialTemplates: EditorialTemplatesState,
    comp: ComponentManagementState
}

const reducers = combineReducers({
    user: userReducer,
    ui: uiReducer,
    editorialTemplates: editorialTemplatesReducer,
    comp: componentManagementReducer
});

export default reducers;
